import { config } from '../config';

const errorMessage = '[apiLimits] error to method';

export const apiLimits = {
  fetchMyLimits: async (axiosPrivate) => {
    try {
      const response = await axiosPrivate.get(config.API.LIMITS.MY);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'fetchMyLimits', error);
      throw error;
    }
  },
};
